export default __webpack_public_path__ + "static/media/4.4a9d5cac.jpg";